import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {ChangeDetectorRef, Component} from "@angular/core";
import {InventoryEntityModel} from "../inventory-entity.model";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {InventoryData} from "../inventory.data";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-inventory-edit-page",
    templateUrl: "./inventory-edit-page.component.html",
    providers: [provideEntityModel(InventoryEntityModel)]
})
export class InventoryEditPageComponent extends AbstractEditPage {

    constructor(public model: InventoryEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }

    addingAnother(previousEntity: InventoryData): void {
        this.model.data.inventoryGroup.invGroupId = previousEntity.inventoryGroup.invGroupId;
    }
}
